/* eslint-disable no-underscore-dangle */
/* eslint-disable no-plusplus */
import React from 'react';
import { IndicatorTimelineRecord } from './IndicatorTimelineRecord';

import { customDateStr } from '../../../../../shared/misc/utils';
import IndicatorBadge from './IndicatorBadge';

interface Props {
  record: IndicatorTimelineRecord;
  className: string;
}

const IndicatorTimelineItem = (props: Props) => {
  const { record, className } = props;

  let formattedValue = record.value;

  if (formattedValue === 'N/A') {
    formattedValue = 'N/A';
  } else if (record.typeCode === '2Decimals' && record.value) {
    formattedValue = parseFloat(record.value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return (
    <div className="indicator-timeline-item">
      <div className="header">{customDateStr(record.date.toString())}</div>
      <div className={`data-container ${className}`}>
        <div className="spr" id={`btnHistory-${record.id}`}>
          {record.value ? (
            <IndicatorBadge value={formattedValue} typeCode={record.typeCode} />
          ) : (
            '-'
          )}
        </div>
      </div>
    </div>
  );
};

export default IndicatorTimelineItem;
